"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Select = _interopRequireDefault(require("../Select"));
var _Text = _interopRequireDefault(require("../Text"));
var _Price = _interopRequireDefault(require("../Price"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _DrinksSelector = _interopRequireDefault(require("./DrinksSelector.proptypes"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__StyledContainer",
  componentId: "sc-1h85a1f-0"
})([""]);
var Container = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__Container",
  componentId: "sc-1h85a1f-1"
})(["display:flex;flex-wrap:wrap;"]);
exports.Container = Container;
var OptionLabel = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__OptionLabel",
  componentId: "sc-1h85a1f-2"
})(["display:flex;align-items:center;"]);
var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__LabelWrapper",
  componentId: "sc-1h85a1f-3"
})(["display:flex;flex-wrap:wrap;"]);
var LabelBreak = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__LabelBreak",
  componentId: "sc-1h85a1f-4"
})(["flex-basis:100%;height:0;"]);
var OptionLabelImage = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__OptionLabelImage",
  componentId: "sc-1h85a1f-5"
})(["display:flex;align-items:center;cursor:", ";pointer-events:", ";margin-right:", ";border-radius:", ";width:48px;height:48px;"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'none' : 'pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'none' : 'auto';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.XSmall;
});
var DrinksImage = _styledComponents.default.img.withConfig({
  displayName: "DrinksSelector__DrinksImage",
  componentId: "sc-1h85a1f-6"
})(["max-width:100%;max-height:100%;object-fit:contain;opacity:", ";"], function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 0.5 : 1;
});
var SelectLabel = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__SelectLabel",
  componentId: "sc-1h85a1f-7"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.default;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeight.medium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.normal;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.normal;
}, function (_ref10) {
  var theme = _ref10.theme,
    disabled = _ref10.disabled;
  return disabled ? theme.colors.greyLight : theme.colors.black;
});
var SelectLabelAmount = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__SelectLabelAmount",
  componentId: "sc-1h85a1f-8"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSize.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.lineHeight.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.greyDark;
});
var SelectedWrapper = _styledComponents.default.div.withConfig({
  displayName: "DrinksSelector__SelectedWrapper",
  componentId: "sc-1h85a1f-9"
})(["display:flex;justify-content:space-between;"]);
var AmountText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DrinksSelector__AmountText",
  componentId: "sc-1h85a1f-10"
})(["font-size:", ";color:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.XSmall;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.greyDark;
});
var DrinksSelector = function DrinksSelector(props) {
  var accessible = props.accessible,
    theme = props.theme,
    translation = props.translation,
    complimentaryDrinks = props.complimentaryDrinks,
    onChangeDrinks = props.onChangeDrinks,
    isDisabled = props.isDisabled,
    isMobile = props.isMobile,
    maxDropdownHeight = props.maxDropdownHeight,
    conversionRates = props.conversionRates,
    currency = props.currency;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedDrinks = _useState2[0],
    setSelectedDrinks = _useState2[1];
  var _useState3 = (0, _react.useState)(isDisabled),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isDisabledDropdown = _useState4[0],
    setIsdisabledDropdown = _useState4[1];
  var drinkListValue = complimentaryDrinks && complimentaryDrinks.length > 0 ? (0, _toConsumableArray2.default)(complimentaryDrinks) : [];
  var lang = _objectSpread(_objectSpread({}, _constants.TRANSLATION), translation);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var drinksSelectionChangeHandler = function drinksSelectionChangeHandler(value) {
    setSelectedDrinks(value);
    var selectedDrink = drinkListValue.find(function (d) {
      return d.id === value;
    });
    onChangeDrinks(selectedDrink);
  };
  (0, _react.useEffect)(function () {
    if (complimentaryDrinks && complimentaryDrinks.length > 0) {
      var isSelectedDrink = complimentaryDrinks.find(function (d) {
        return d.isSelected === true;
      });
      drinksSelectionChangeHandler(isSelectedDrink === null || isSelectedDrink === void 0 ? void 0 : isSelectedDrink.id);
      if (complimentaryDrinks.length === 1) {
        setIsdisabledDropdown(true);
      }
    }
  }, []);
  var getDrinkPrice = function getDrinkPrice(drinkPrice, drinkCurrency) {
    var price = _utilities.default.getConvertedCurrency(drinkPrice !== null && drinkPrice !== void 0 ? drinkPrice : 0, currency || drinkCurrency, conversionRates);
    return _utilities.default.currencyFormat(price);
  };
  var customSelectLabel = function customSelectLabel(item) {
    return /*#__PURE__*/_react.default.createElement(OptionLabel, null, /*#__PURE__*/_react.default.createElement(OptionLabelImage, {
      disabled: item.disabled
    }, /*#__PURE__*/_react.default.createElement(DrinksImage, {
      src: item.imageUrl
    })), /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(SelectLabel, null, item.name), /*#__PURE__*/_react.default.createElement(LabelBreak, null), (item === null || item === void 0 ? void 0 : item.price) > 0 && /*#__PURE__*/_react.default.createElement(SelectLabelAmount, null, "+", /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      amount: getDrinkPrice(item.price, item.currency),
      color: _constants.TEXT_TYPE.small.color,
      customFontSize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      customCurrencySize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      currency: currency,
      allowLocaleFormat: true,
      defaultIDRLocale: false,
      noDecimalValues: false
    }), (item === null || item === void 0 ? void 0 : item.slashedPrice) > 0 && /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      amount: getDrinkPrice(item.slashedPrice, item.currency),
      color: _constants.TEXT_TYPE.small.color,
      customFontSize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      customCurrencySize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      currency: currency,
      allowLocaleFormat: true,
      defaultIDRLocale: false,
      noDecimalValues: false,
      strikethrough: true
    }))));
  };
  var customSelectValue = function customSelectValue(item) {
    return /*#__PURE__*/_react.default.createElement(SelectedWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, item.name), (item === null || item === void 0 ? void 0 : item.price) > 0 && /*#__PURE__*/_react.default.createElement(AmountText, null, "+", /*#__PURE__*/_react.default.createElement(_Price.default, {
      accessible: accessible,
      amount: getDrinkPrice(item.price, item.currency),
      color: _constants.TEXT_TYPE.small.color,
      customFontSize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      customCurrencySize: isMobile ? _constants.TEXT_TYPE.small.type : _constants.TEXT_TYPE.small.type,
      currency: currency,
      allowLocaleFormat: true,
      defaultIDRLocale: false,
      noDecimalValues: false
    })));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledContainer, null, drinkListValue && drinkListValue.length > 0 && /*#__PURE__*/_react.default.createElement(_Select.default, {
      accessible: accessible,
      theme: theme,
      label: lang.drinksLabel,
      items: drinkListValue.map(function (item) {
        return {
          name: item.name,
          value: item.id,
          imageUrl: item.imageUrl,
          price: item.price,
          slashedPrice: item.slashedPrice,
          currency: item.currency
        };
      }),
      value: selectedDrinks,
      height: _constants.CONTAINER_HEIGHT,
      onChange: drinksSelectionChangeHandler,
      renderDisplayValue: function renderDisplayValue(item) {
        return customSelectValue(item);
      },
      renderOptionLabel: function renderOptionLabel(item) {
        return customSelectLabel(item);
      },
      disabled: isDisabledDropdown,
      isMobileV2: isMobile,
      showPicker: true,
      maxHeight: maxDropdownHeight,
      mobileZIndex: _constants.MOBILE_ZINDEX_VALUE
    }));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
DrinksSelector.propTypes = _DrinksSelector.default.PropTypes;
DrinksSelector.defaultProps = _DrinksSelector.default.DefaultProps;
var _default = DrinksSelector;
exports.default = _default;